"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * PRG - POST Redirect GET Utilities
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.prg = {
    form: null,
    formValue: null,
    initialize: function () {
        'use strict';
        this.form = $('#tx_gs1base_prg_form');
        this.formValue = $('#prg_data');
        this.addLinkEvents();
    },
    /**
     * PRG Login - GSONE-1877
     */
    addLinkEvents: function () {
        'use strict';
        $('[data-prg-link]')
            .off('click.txGs1Base')
            .on('click.txGs1Base', function (event) {
            event.preventDefault();
            var element = $(this), prgData = element.attr('data-prg-data');
            if (prgData) {
                if (element.is('[rel=contentbox]')) {
                    _main_1.txGs1Base.prg.openInModal(prgData);
                }
                else {
                    _main_1.txGs1Base.prg.redirect(prgData);
                }
            }
        });
    },
    /**
     * Redirect user using form
     */
    redirect: function (prgData) {
        'use strict';
        this.formValue.val(prgData);
        this.form.trigger('submit');
    },
    /**
     * Open in modal
     */
    openInModal: function (prgData) {
        'use strict';
        this.formValue.val(prgData);
        $.fancybox.showLoading();
        $.ajax({
            type: 'POST',
            cache: false,
            url: '/',
            data: this.form.serializeArray(),
            success: function (data) {
                $.fancybox.open(data, $.extend(true, _main_1.txGs1Base.content.lightbox.fancyboxDefaultOptions, {
                    afterShow: function () {
                        $.eventEmitter.emit('contentUpdate');
                        $('.modal-dialog').animate({
                            top: 0,
                            opacity: 1
                        }, 500);
                    }
                }));
            }
        });
    }
};
exports.default = {};
